import React from 'react';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import JsBarcode from 'jsbarcode';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class EtiquetaRoupaPDF extends React.Component {
  generatePDF = () => {
    const { produto } = this.props;
    const barcodeOptions = {
      format: 'CODE128',
      displayValue: false,
      fontSize: 10,
      lineColor: '#000',
      width: 1,
      height: 30 // Ajuste da altura do código de barras
    };

    function abreviarString(str, maxLength) {
      if (str.length > maxLength) {
        return str.slice(0, maxLength - 1) + '.';
      }
      return str;
    }

    const descricao = abreviarString(produto.DESCRICAO, 19);

    const canvas = document.createElement('canvas');
    JsBarcode(canvas, produto.COD_PRODUTO, barcodeOptions);
    const barcodeDataURL = canvas.toDataURL('image/png');

    const generateColumnContent = () => [
      {
        image: barcodeDataURL,
        width: 90,
        height: 30,
        alignment: 'center'
      },
      {
        text: produto.COD_PRODUTO,
        style: 'codigo',
        fontSize: 8,
        alignment: 'center',
        margin: [0, 5, 0, 0]
      },
      {
        text: 'Data: __/__/____',
        style: 'item',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 10, 0, 0]
      },
      {
        text: descricao,
        style: 'item',
        fontSize: 9,
        alignment: 'center',
        margin: [0, 10, 0, 0]
      },
      {
        text: produto.VENDA.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
        style: 'item',
        fontSize: 12,
        alignment: 'center',
        margin: [0, 10, 0, 0]
      }
    ];

    const documentDefinition = {
      pageSize: {
        width: 283.46, // 100mm em pontos (1mm = 2.8346 pontos)
        height: 141.73 // 50mm em pontos
      },
      pageMargins: [10, 10, 10, 10], // Margens de 10 pontos
      content: [
        {
          columns: [
            { stack: generateColumnContent(), width: '33%' },
            { stack: generateColumnContent(), width: '33%' },
            { stack: generateColumnContent(), width: '33%' }
          ]
        }
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          alignment: 'center',
          margin: [0, 0, 0, 20]
        },
        item: {
          bold: true,
          alignment: 'center'
        },
        codigo: {
          bold: true,
          alignment: 'center'
        }
      }
    };

    pdfMake.createPdf(documentDefinition).open();
  };

  render() {
    return (
      <div>
        <button onClick={this.generatePDF} className='dropdown-item'>
          <i className="fas fa-barcode etiquetaIcon"></i> Roupa
        </button>
      </div>
    );
  }
}

export default EtiquetaRoupaPDF;

